module.exports = __webpack_public_path__ + "img/add-24px.6edbf04d.svg";